import { render, staticRenderFns } from "./detail-sd.vue?vue&type=template&id=7878d3de&scoped=true"
import script from "./detail-sd.vue?vue&type=script&lang=js"
export * from "./detail-sd.vue?vue&type=script&lang=js"
import style0 from "./detail-sd.vue?vue&type=style&index=0&id=7878d3de&prod&lang=scss&scoped=true"
import style1 from "./detail-sd.vue?vue&type=style&index=1&id=7878d3de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878d3de",
  null
  
)

export default component.exports